import React from 'react';
import * as Config from '../config/Config';
import * as Common from '../helpers/Common';
const win=window;
const $=win.$;

export default class Timecountdown extends React.Component {

  	constructor(props) {
    	super(props);
      this.state = { apicall:'',num1of:1,num2of:1,}
  	}

  	componentDidMount(){
      let self = this;
      let vcdata = self.props;
  		let minuts = 25;//dummy - not using anywhere
      let seconds = vcdata.seconds; //1min 5seconds
      let timer = undefined;
      let isStarted = false;
      let isPaused = false;
      let n1,n2,n3,hrs ='';
      let num1,num2=1;
      if(!isStarted){

        this.timer  = setInterval(function(){
          seconds--;
          hrs = Math.floor(seconds/3600);
          n1 = Math.floor(seconds/60);
          n3 = (n1>60)?(n1 % 60):n1;
          n2 = (seconds % 60);
          num1 = self.cuntdown(n1);
          num2 = self.cuntdown(n2);
          
          self.setState({num1of:num1,num2of:num2});

          if(hrs>0){
            $("#timer").text(hrs+":"+n3+ ":" + num2);
          }else {
            $("#timer").text(self.cuntdown(n3)+ ":" + num2);
          }
          if(seconds == 0) { 
            clearInterval(this.timer);
            if(vcdata.allowaddtimer==undefined || vcdata.allowaddtimer==1)
            {
              self.questionautocompelete(vcdata.details);
            }
            else
            {
              Common.message('Note!','Sorry, Your time is exceeded','info'); 
              self.props.tfs({componentStatus:'incompleted'});
            }   

            }}, 1000);

        self.setState({apicall:'1'});
        if(this.props.allowaddtimer==undefined || this.props.allowaddtimer==1)
        {
          this.myInterval = setInterval(function(){
            if(self.state.apicall=='1'){ self.addtimer(vcdata.details,num1,num2,vcdata.question_number); }
            }, 3000);
        }
        

        isStarted = true;
      }
  	}

    questionautocompelete(data){
      Common.reactLoader("show", "Please wait...");
      fetch(Config.domainUrl+'normal-test/autosaveall', {
        method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization':'Bearer ' +Common.getTokenData()
          },
          body: JSON.stringify({data})
      }).then((response) => response.json()).then((responseJson) => {
        Common.scrollToTop();
        if (responseJson.isCompletedFully) {
            this.props.goToThanksPage();
        } else {
            Common.message('Note!','Sorry, Your time is exceeded','info');
            this.props.tfs(responseJson);
            Common.reactLoader("hide");
        }
      });
    }

    cuntdown(num){
      num = num.toString();
      return (num.length>1) ? num:'0'+num;
    }

    componentWillUnmount() {
      clearInterval(this.myInterval);
      clearInterval(this.timer);
      let vcdata = this.props;
      if(vcdata.allowaddtimer==undefined || vcdata.allowaddtimer==1)
      {
       this.addtimer(vcdata.details,this.state.num1of,this.state.num2of,vcdata.question_number);
      }
    }

    addtimer(data,min,seconds,question_number){
      fetch(Config.domainUrl+'normal-test/savetimerdet', {
        method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization':'Bearer ' +Common.getTokenData()
          },
          body: JSON.stringify({data,'min':min,'seconds':seconds,'question_number':question_number})
      }).then((response) => response.json()).then((responseJson) => {});
    }
    render() {
    	return (
        <div id="floatdiv" className="timer">
          <div className="timer_txt">Time Taken - <span id="timer" className="text-center">00:00</span></div>
        </div>
    	);
  	}
}



// WEBPACK FOOTER //
// ./src/components/Timecountdown.js